/**
 * Which signing link (`#/sign/<token>`) a URL fragment names. Pure, so it can be
 * tested without a browser; useSigningLink.ts reads the page's own fragment with it.
 */

const SIGNING_HASH = /^#\/sign\/([A-Za-z0-9_-]{43})(?:[/?#].*)?$/

/** The link token a fragment names (`#/sign/<token>`), else null. */
export function signingTokenOf(hash: string): string | null {
  return hash.match(SIGNING_HASH)?.[1] ?? null
}

/**
 * Whether a change of fragment must load the page again.
 *
 * The page decides once, at load, whether it is a signing page and for which link
 * (useSigningLink.ts). Pasting a link into the address bar of an open tab of this
 * origin changes only the fragment, which a browser does not load again: a portal
 * tab's router sent a signing link to the dashboard, dropping the token, and an
 * open signing page went on showing the link it was opened with, its "you have
 * signed" included, for a person who had not signed the new one yet.
 */
export function hashChangeNeedsReload(loadedToken: string | null, newUrl: string): boolean {
  let hash: string
  try {
    hash = new URL(newUrl).hash
  } catch {
    return false
  }
  return signingTokenOf(hash) !== loadedToken
}
